import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { HelpersService } from 'libs/shared/src/lib/services/helpers.service';
import { OrdersService } from 'libs/shared/src/lib/services/orders.service';

export interface DialogData {
  isDeleteModal: boolean,
  paymentMethods: any,
  detail: any
}

@Component({ standalone: false,
  selector: 'vfa-cp-subscription-renewal-modal',
  templateUrl: './subscription-renewal-modal.component.html',
  styleUrls: ['./subscription-renewal-modal.component.scss']
})
export class SubscriptionRenewalModal implements OnInit {
  public wait: boolean = false;
  public waitDeflag: boolean = false;
  public waitSave: boolean = false;
  public waitStripeLoaded: boolean = false;
  public formCompleted: boolean = false;
  @Output() submitted: EventEmitter<any> = new EventEmitter;

  constructor(public ordersService: OrdersService, public helpersService: HelpersService, @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog) { }

  ngOnInit(): void {

  }

  public changeWaitSave(event: any) {
    this.waitSave = event;
  }

  public formCompletedCheck(event: any) {
    this.formCompleted = event;
  }

  public changeWaitStripeLoaded(event: any) {
    this.waitStripeLoaded = event;
  }

  public startPaymentError(event: any) {
    this.closeModal();
  }

  public confirmAssetSEPA() {
    const submitCardButton = document.getElementById("submit");
    if(submitCardButton) {
      submitCardButton.click();
    }
  }

  public closeModal() {
    this.dialog.closeAll();
  }

  public confirmPayment(intent: any) {
    if(intent) {
      this.waitSave = true;
      this.ordersService.confirmSubscriptionIntent(this.data.detail.id, intent).subscribe(() => {
        //submitted isDeleteModal (false or true)
        this.submitted.emit(false);
        const msg = this.helpersService.instant("success-autorenewal-sub-toast");
        this.ordersService.showToast(msg, 'success');
        this.closeModal();
        this.waitSave = false;
      }, err => {
        this.ordersService.showToast(this.ordersService.getError(err), 'danger');
        this.waitSave = false;
      })
    }
  }

  public unsubscribeService() {
    this.submitted.emit(true);
    this.closeModal();
  }
}

